<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="estoques.content"
      class="mt-5 mb-5"
      :loading="loading"
      :server-items-length="estoques.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum estoque encontrado"
      loading-text="Carregando estoque..."
      :options="optionsList"
    >
      <template v-slot:item.comprador.nome="{ item }">
        {{ item.comprador.pessoa.nome }}
      </template>
      <template v-slot:item.deposito.descricao="{ item }">
        {{ item.deposito.descricao }}
      </template>
      <template v-slot:item.saldo="{ item }">
        {{ item.saldo }}
      </template>
    </v-data-table>
  </div>
</template>

<script>


export default {
  props: {
    estoques: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Filial',
          value: 'comprador.nome',
          sortable: true,
        },
        {
          text: 'Depósito',
          value: 'deposito.descricao',
          sortable: true,
        },
        {
          text: 'Saldo',
          value: 'saldo',
          sortable: true,
        },
      ],
    };
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
};
</script>
